export const translations = {
  de: {
    company: "Equi-Integral-International",
    tagline: "Ihr Ansprechpartner – Ausbildung, Hufbeschlag & Rehabilitation",
    nav_login: "Kunden-Login",
    book_consultation: "Beratung buchen",
    book_riding: "Online-Reitunterricht buchen",
    hero_sub: "Kunden- & Patientenverwaltung, Online-Buchungen und Zahlungen an einem Ort.",
    footer_riding: "Springreiten",
    footer_dressage: "Dressur",
    footer_stable: "Führen im Stall",
    footer_farrier: "Hufbeschlag",
    // form generic
    name: "Name",
    email: "E-Mail",
    phone: "Telefon",
    horse_name: "Pferdename",
    case_description: "Fallbeschreibung",
    preferred_date: "Wunschtermin",
    experience_notes: "Erfahrung / Notizen",
    submit: "Absenden",
    back: "Zurück",
    // consultation
    consultation_title: "Beratung buchen",
    consultation_hint: "Beratung kostet 75 € – 200 € je nach Aufwand. Zahlung per PayPal oder Überweisung.",
    // riding
    riding_title: "Online-Reitunterricht buchen",
    package: "Paket-Auswahl",
    pkg_single: "Einzelstunde – 75 €",
    pkg_ten: "10er-Paket – 400 € (= 40 €/Einheit)",
    riding_hint: "Unterricht per PIVO. Zahlung per PayPal oder Überweisung.",
    // success
    success_title: "Vielen Dank!",
    success_msg: "Ihre Anfrage wurde übermittelt. Wir melden uns in Kürze bei Ihnen.",
    pay_paypal: "Jetzt per PayPal bezahlen",
    // auth
    login: "Anmelden",
    register: "Registrieren",
    password: "Passwort",
    to_register: "Noch kein Konto? Registrieren",
    to_login: "Bereits registriert? Anmelden",
    logout: "Abmelden",
    // customer
    welcome: "Willkommen",
    my_horses: "Meine Pferde",
    no_horses: "Ihnen sind noch keine Pferde zugeordnet.",
    breed: "Rasse",
    age: "Alter",
    color: "Farbe",
    owner: "Besitzer",
    notes: "Notizen",
    // admin
    patients: "Patienten",
    requests: "Anfragen",
    new_badge: "Neu",
    add_horse: "Pferd anlegen",
    // horse file
    treatment: "Behandlungsplan",
    material: "Material",
    reports: "Berichte",
    export_pdf: "Als PDF exportieren",
    add_entry: "Eintrag hinzufügen",
    entry_title: "Titel",
    entry_date: "Datum",
    entry_desc: "Beschreibung",
    no_entries: "Keine Einträge vorhanden.",
    delete: "Löschen",
    save: "Speichern",
    edit: "Bearbeiten",
    // horse form
    horse_form_new: "Neues Pferd",
    horse_form_edit: "Pferd bearbeiten",
    owner_name: "Besitzer-Name",
    owner_email: "Besitzer-E-Mail",
    owner_phone: "Besitzer-Telefon",
    // request detail
    request_detail: "Anfrage-Detail",
    type: "Typ",
    type_consultation: "Beratung",
    type_riding: "Reitunterricht",
    status: "Status",
    status_new: "Neu",
    status_reviewed: "Geprüft",
    status_closed: "Abgeschlossen",
    mark_reviewed: "Als geprüft markieren",
    mark_closed: "Als abgeschlossen markieren",
    // toasts
    t_booked: "Anfrage erfolgreich gesendet",
    t_login_ok: "Erfolgreich angemeldet",
    t_saved: "Gespeichert",
    t_deleted: "Gelöscht",
    t_error: "Ein Fehler ist aufgetreten",
    confirm_delete: "Wirklich löschen?",
  },
  en: {
    company: "Equi-Integral-International",
    tagline: "Your contact – training, farriery & rehabilitation",
    nav_login: "Customer Login",
    book_consultation: "Book Consultation",
    book_riding: "Book Online Riding Lesson",
    hero_sub: "Customer & patient management, online bookings and payments in one place.",
    footer_riding: "Show Jumping",
    footer_dressage: "Dressage",
    footer_stable: "Leading in the stable",
    footer_farrier: "Farriery",
    name: "Name",
    email: "Email",
    phone: "Phone",
    horse_name: "Horse name",
    case_description: "Case description",
    preferred_date: "Preferred date",
    experience_notes: "Experience / notes",
    submit: "Submit",
    back: "Back",
    consultation_title: "Book Consultation",
    consultation_hint: "Consultation costs €75 – €200 depending on effort. Payment via PayPal or bank transfer.",
    riding_title: "Book Online Riding Lesson",
    package: "Package selection",
    pkg_single: "Single lesson – €75",
    pkg_ten: "10-pack – €400 (= €40/unit)",
    riding_hint: "Lessons via PIVO. Payment via PayPal or bank transfer.",
    success_title: "Thank you!",
    success_msg: "Your request has been submitted. We will contact you shortly.",
    pay_paypal: "Pay now with PayPal",
    login: "Log in",
    register: "Register",
    password: "Password",
    to_register: "No account yet? Register",
    to_login: "Already registered? Log in",
    logout: "Log out",
    welcome: "Welcome",
    my_horses: "My Horses",
    no_horses: "No horses are assigned to you yet.",
    breed: "Breed",
    age: "Age",
    color: "Color",
    owner: "Owner",
    notes: "Notes",
    patients: "Patients",
    requests: "Requests",
    new_badge: "New",
    add_horse: "Add horse",
    treatment: "Treatment plan",
    material: "Material",
    reports: "Reports",
    export_pdf: "Export as PDF",
    add_entry: "Add entry",
    entry_title: "Title",
    entry_date: "Date",
    entry_desc: "Description",
    no_entries: "No entries yet.",
    delete: "Delete",
    save: "Save",
    edit: "Edit",
    horse_form_new: "New horse",
    horse_form_edit: "Edit horse",
    owner_name: "Owner name",
    owner_email: "Owner email",
    owner_phone: "Owner phone",
    request_detail: "Request detail",
    type: "Type",
    type_consultation: "Consultation",
    type_riding: "Riding lesson",
    status: "Status",
    status_new: "New",
    status_reviewed: "Reviewed",
    status_closed: "Closed",
    mark_reviewed: "Mark as reviewed",
    mark_closed: "Mark as closed",
    t_booked: "Request sent successfully",
    t_login_ok: "Logged in successfully",
    t_saved: "Saved",
    t_deleted: "Deleted",
    t_error: "An error occurred",
    confirm_delete: "Really delete?",
  },
};
